import type { ReactNode } from "react";
import { Breadcrumb } from "./breadcrumb";

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  breadcrumbs?: { label: string; href?: string }[];
  actions?: ReactNode;
  size?: "default" | "large";
  titleAddon?: ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  breadcrumbs,
  actions,
  size = "default",
  titleAddon,
}: PageHeaderProps) {
  const isLarge = size === "large";

  return (
    <div className="flex items-start justify-between">
      <div className="flex flex-col">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumb items={breadcrumbs} className="mb-0.5" />
        )}
        <div className={isLarge ? "flex items-center gap-4" : "flex items-baseline gap-3"}>
          <h1
            className={
              isLarge
                ? "text-2xl font-bold tracking-tight"
                : "text-lg font-bold text-foreground tracking-tight"
            }
          >
            {title}
          </h1>
          {titleAddon}
          {subtitle && (
            <span
              className={
                isLarge ? "text-sm text-muted-foreground" : "text-xs text-muted-foreground"
              }
            >
              {subtitle}
            </span>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
